<div class="modal-content">
  <div class="modal-header bg-tertiary">
    <h6 class="modal-title fw-bold">Postback Logs</h6>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
  </div>

  <div class="modal-body">
    <div class="row g-2 align-items-end mb-3">
      <div class="col-auto">
        <app-date-range-selector [date]="'this-month'" [zone]="'Europe/Paris'"
          (dateChanged)="updateRange($event)"></app-date-range-selector>
      </div>
      <div class="col-auto">
        <label class="form-label">HTTP response</label>
        <select class="form-select" [(ngModel)]="status" (change)="onFilterChange()">
          <option value="">All</option>
          <option value="ok">OK only</option>
          <option value="ko">KO only</option>
        </select>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table" style="white-space: unset;">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="createdAt">Date</th>
            <th>URL</th>
            <th tableSorterHeader="statusCode">HTTP response</th>
            <th tableSorterHeader="duration">Duration</th>
            <th>Error</th>
          </tr>
        </thead>
        <tbody>
          @for (log of logs; track log) {
            <tr>
              <td>{{ log.id }}</td>
              <td>{{ log.createdAt | parisDate }}</td>
              <td>{{ log.url }}</td>
              <td>{{ log.statusCode }}</td>
              <td>{{ log.duration }}</td>
              <td>{{ log.error }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
  </div>
</div>
